"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ScrumboardMainView;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const react_router_dom_1 = require("react-router-dom");
const MainSetupReact_1 = __importDefault(require("../React/MainSetupReact"));
const CurrentSprintTab_1 = __importDefault(require("./CurrentSprint/CurrentSprintTab"));
const MyTasksTab_1 = __importDefault(require("./MyTasks/MyTasksTab"));
const PlanningTab_1 = __importDefault(require("./Planning/PlanningTab"));
const ScrumboardApi_1 = __importDefault(require("./ScrumboardApi"));
const TimesSummaryTab_1 = __importDefault(require("./TimesSummary/TimesSummaryTab"));
require("./Scrumboard.css");
const TAB_KEYS = ["currentSprint", "timesSummary", "myTasks", "planning"];
const DEFAULT_TAB = "currentSprint";
/**
 * Główny widok Scrumboarda (następca arkuszy Google).
 * Urlopy mieszkały tu jako piąta zakładka - wyprowadzone do Biuro → Urlopy,
 * bo to sprawa kadrowa, nie scrumowa. Trasy backendu zostały pod /scrumboard/*.
 */
function ScrumboardMainView() {
    // Aktywna zakładka w URL (#/scrumboard?tab=...), aby przetrwała odświeżenie i była linkowalna.
    const [searchParams, setSearchParams] = (0, react_router_dom_1.useSearchParams)();
    const tabParam = searchParams.get("tab");
    const activeKey = tabParam && TAB_KEYS.includes(tabParam) ? tabParam : DEFAULT_TAB;
    const setActiveKey = (k) => setSearchParams({ tab: k }, { replace: true });
    const [confirm, setConfirm] = (0, react_1.useState)(null);
    const [reportUrl, setReportUrl] = (0, react_1.useState)(null);
    const [error, setError] = (0, react_1.useState)(null);
    const canManage = MainSetupReact_1.default.isRoleAllowed(["ADMIN", "ENVI_MANAGER"]);
    (0, react_1.useEffect)(() => {
        document.title = "Scrumboard";
    }, []);
    function askResetDiscussed() {
        setConfirm({
            title: "Resetuj status omówienia",
            body: "Na pewno wyzerować „Omówiony na planowaniu” dla WSZYSTKICH umów?",
            action: () => runAction(() => ScrumboardApi_1.default.resetDiscussed()),
        });
    }
    function askResetHours() {
        setConfirm({
            title: "Resetuj czasy rzeczywiste",
            body: "Na pewno wyzerować wszystkie godziny rzeczywiste bieżącego tygodnia dla WSZYSTKICH zadań?",
            action: () => runAction(() => ScrumboardApi_1.default.resetHours()),
        });
    }
    async function runAction(fn) {
        setConfirm(null);
        try {
            await fn();
        }
        catch (err) {
            setError(err instanceof Error ? err.message : String(err));
        }
    }
    async function generateReport() {
        setReportUrl(null);
        try {
            const result = await ScrumboardApi_1.default.generateReport();
            setReportUrl(result.url);
        }
        catch (err) {
            setError(err instanceof Error ? err.message : String(err));
        }
    }
    return (react_1.default.createElement(react_bootstrap_1.Card, { className: "scrumboard-view" },
        react_1.default.createElement(react_bootstrap_1.Card.Body, null,
            error && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger", dismissible: true, onClose: () => setError(null) }, error)),
            reportUrl && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "success", dismissible: true, onClose: () => setReportUrl(null) },
                "Raport wygenerowany.",
                " ",
                react_1.default.createElement(react_bootstrap_1.Alert.Link, { href: reportUrl, target: "_blank", rel: "noreferrer" }, "Otw\u00F3rz arkusz"))),
            react_1.default.createElement("div", { className: "scrum-tabbar-wrap" },
                canManage && (react_1.default.createElement("div", { className: "scrum-tab-actions d-flex gap-2" },
                    react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-secondary", size: "sm", onClick: askResetDiscussed }, "Resetuj om\u00F3wienie"),
                    react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-secondary", size: "sm", onClick: askResetHours }, "Resetuj czasy"),
                    react_1.default.createElement(react_bootstrap_1.Button, { variant: "primary", size: "sm", onClick: generateReport }, "Generuj raport"))),
                react_1.default.createElement(react_bootstrap_1.Tabs, { id: "scrumboard-tabs", activeKey: activeKey, onSelect: (k) => setActiveKey(k ?? DEFAULT_TAB), className: "mb-3", mountOnEnter: true },
                    react_1.default.createElement(react_bootstrap_1.Tab, { eventKey: "currentSprint", title: "Aktualny Sprint" },
                        react_1.default.createElement(CurrentSprintTab_1.default, null)),
                    react_1.default.createElement(react_bootstrap_1.Tab, { eventKey: "timesSummary", title: "Podsumowanie godzin" },
                        react_1.default.createElement(TimesSummaryTab_1.default, { active: activeKey === "timesSummary" })),
                    react_1.default.createElement(react_bootstrap_1.Tab, { eventKey: "myTasks", title: "Moje zadania" },
                        react_1.default.createElement(MyTasksTab_1.default, null)),
                    react_1.default.createElement(react_bootstrap_1.Tab, { eventKey: "planning", title: "Planowanie" },
                        react_1.default.createElement(PlanningTab_1.default, null))))),
        react_1.default.createElement(react_bootstrap_1.Modal, { show: !!confirm, onHide: () => setConfirm(null), centered: true },
            react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
                react_1.default.createElement(react_bootstrap_1.Modal.Title, null, confirm?.title)),
            react_1.default.createElement(react_bootstrap_1.Modal.Body, null, confirm?.body),
            react_1.default.createElement(react_bootstrap_1.Modal.Footer, null,
                react_1.default.createElement(react_bootstrap_1.Button, { variant: "secondary", onClick: () => setConfirm(null) }, "Anuluj"),
                react_1.default.createElement(react_bootstrap_1.Button, { variant: "danger", onClick: () => confirm?.action() }, "Potwierd\u017A")))));
}
